var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 915,
    height: 915,
    viewBox: "0 0 915 915",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427 127H490L460.226 477L427 127Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.687 149.328L645.547 177.786L460.095 476.543L589.687 149.328Z",
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724.72 247.23L761.064 298.312L458.389 477.299L724.72 247.23Z",
    fill: "currentColor"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.102 396.517L807.674 458.619L456.528 477.18L799.102 396.517Z",
    fill: "currentColor"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.937 563.276L774.79 622.294L454.933 476.212L795.937 563.276Z",
    fill: "currentColor"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.943 709.631L669.881 752.157L453.967 474.616L715.943 709.631Z",
    fill: "currentColor"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.292 802.339L516.777 818.715L453.85 472.755L577.292 802.339Z",
    fill: "currentColor"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.476 820.34L350.253 806.846L454.607 471.05L411.476 820.34Z",
    fill: "currentColor"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.159 759.545L208.137 719.246L456.067 469.889L256.159 759.545Z",
    fill: "currentColor"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.624 633.765L122.708 575.814L457.9 469.537L146.624 633.765Z",
    fill: "currentColor"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.747 471.568L113.371 409.13L459.686 470.072L107.747 471.568Z",
    fill: "currentColor"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.362 309.799L182.248 257.055L461.023 471.374L148.362 309.799Z",
    fill: "currentColor"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.241 185.201L313.692 154.132L461.605 473.146L259.241 185.201Z",
    fill: "currentColor"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter13_f_2033_1692)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 457.5,
    cy: 457.5,
    r: 157.5,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2033_1692",
    x: 411,
    y: 111,
    width: 95,
    height: 382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2033_1692",
    x: 444.095,
    y: 133.328,
    width: 217.452,
    height: 359.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2033_1692",
    x: 442.389,
    y: 231.23,
    width: 334.674,
    height: 262.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2033_1692",
    x: 440.528,
    y: 380.517,
    width: 383.146,
    height: 112.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2033_1692",
    x: 438.933,
    y: 460.213,
    width: 373.004,
    height: 178.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2033_1692",
    x: 437.968,
    y: 458.615,
    width: 293.976,
    height: 309.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2033_1692",
    x: 437.85,
    y: 456.755,
    width: 155.442,
    height: 377.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2033_1692",
    x: 334.253,
    y: 455.05,
    width: 136.354,
    height: 381.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2033_1692",
    x: 192.137,
    y: 453.89,
    width: 279.931,
    height: 321.655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2033_1692",
    x: 106.708,
    y: 453.537,
    width: 367.192,
    height: 196.228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2033_1692",
    x: 91.7471,
    y: 393.13,
    width: 383.939,
    height: 94.4385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2033_1692",
    x: 132.362,
    y: 241.055,
    width: 344.661,
    height: 246.319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2033_1692",
    x: 243.241,
    y: 138.132,
    width: 234.364,
    height: 351.015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2033_1692",
    x: 0,
    y: 0,
    width: 915,
    height: 915,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2033_1692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_1692",
    x1: 458.5,
    y1: 127,
    x2: 458.5,
    y2: 477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2033_1692",
    x1: 617.617,
    y1: 163.557,
    x2: 458.565,
    y2: 475.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2033_1692",
    x1: 742.892,
    y1: 272.771,
    x2: 457.394,
    y2: 475.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2033_1692",
    x1: 803.388,
    y1: 427.568,
    x2: 456.293,
    y2: 475.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2033_1692",
    x1: 785.363,
    y1: 592.785,
    x2: 455.512,
    y2: 474.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2033_1692",
    x1: 692.912,
    y1: 730.894,
    x2: 455.229,
    y2: 473.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2033_1692",
    x1: 547.034,
    y1: 810.527,
    x2: 455.508,
    y2: 472.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2033_1692",
    x1: 380.865,
    y1: 813.593,
    x2: 456.285,
    y2: 471.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2033_1692",
    x1: 232.148,
    y1: 739.395,
    x2: 457.383,
    y2: 470.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2033_1692",
    x1: 134.666,
    y1: 604.789,
    x2: 458.555,
    y2: 471.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2033_1692",
    x1: 110.559,
    y1: 440.349,
    x2: 459.532,
    y2: 471.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2033_1692",
    x1: 165.305,
    y1: 283.427,
    x2: 460.095,
    y2: 472.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2033_1692",
    x1: 286.466,
    y1: 169.667,
    x2: 460.113,
    y2: 473.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27F13F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F13F",
    stopOpacity: 0.48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWin);
export default __webpack_public_path__ + "static/media/win.c7f8dd0448304ee44757febf93219b68.svg";
export { ForwardRef as ReactComponent };